import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom/dist";
import event from "../../image/event.jpg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { StorageDataClient } from "../../store/slice/InfoClientSlice";
import BottomBar from "../../composant/navbar/ButtomBar";
import OkprintLogo from "../../image/okprintLogo.jpg";
import TitreTypography from "../../composant/Typography/TitreTypography";
import SousTitreTypography from "../../composant/Typography/SousTitreTypography";

export const stylebox = {
  cursor: "pointer",
  color: "black",
  outline: "none",
  fontWeight: "bold",
};

export const TextStyle = {
  fontWeight: "bold",
  fontSize: "1rem",
};

export default function Home() {
  const { Produits } = useSelector((state) => state.dataApp);
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const magasin = urlParams.get("magasin");
    if (magasin) {
      const existingData = JSON.parse(localStorage.getItem("infoclient")) || {};
      const magasinId = parseInt(magasin);
      const updatedData = { ...existingData, magasin: magasinId };
      localStorage.setItem("infoclient", JSON.stringify(updatedData));
      dispatch(StorageDataClient(updatedData));
    }
  }, [dispatch]);

  return (
    <>
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <Box>
          <Grid
            container
            textAlign="center"
            spacing={2}
            marginRight="auto"
            rowSpacing={4}
            padding="4%"
          >
            <Grid item xs={12} textAlign="left">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginTop: { xs: "5%", md: "0%" },
                }}
              >
                <Box
                  sx={{
                    width: { xs: 60, md: 100 },
                    height: { xs: 60, md: 100 },
                    borderRadius: "50%",
                    backgroundColor: "white",
                    padding: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={OkprintLogo}
                    alt="logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Box sx={stylebox}>
                  <TitreTypography
                    sx={{
                      fontFamily: "'F37 Ginger', sans-serif",
                      fontWeight: 700,
                      lineHeight: "110%",
                      letterSpacing: "-0.75%",
                      fontSize: {
                        xs: "24px",
                        md: "36px",
                        lg: "48px",
                        xl: "60px",
                      },
                      // Optional: if you want to ensure leading-trim effect in modern browsers
                      // leadingTrim: "none" // not widely supported yet
                    }}
                  >
                    Hello
                  </TitreTypography>

                  <SousTitreTypography
                    sx={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 400,
                      lineHeight: "110%",
                      letterSpacing: "0%",
                      fontSize: {
                        xs: "14px", // extra-small screens
                        md: "26px", // medium screens
                        lg: "28px", // large screens
                        xl: "30px", // extra-large screens
                      },
                      // leadingTrim: "none" // optional, experimental property
                    }}
                  >
                    welcome to ok Print
                  </SousTitreTypography>
                </Box>
              </Box>
            </Grid>
            {/**    <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <CarouselSlider />
              </Box>
            </Grid> */}

            <Grid item xs={12} sx={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{
                  marginTop: "25px",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: "17px",
                  lineHeight: "110%", // يعادل 1.1
                  letterSpacing: "0em", // 0%
                  color: "#1D1E20",
                }}
              >
                Choisissez votre produit
              </Typography>
            </Grid>
            {Produits?.map((p) => (
              <Grid item xs={6} sm={3}>
                <Link
                  to={`/InformationProduct/${p.NomProduit}`}
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      background: "white",
                      padding: "1px",
                      borderRadius: "16px",
                      width: "100%",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Box
                        component="img"
                        src={p.url_Image}
                        alt="polaroid"
                        sx={{
                          borderTopLeftRadius: "16px",
                          borderTopRightRadius: "16px",
                          width: { xs: "100%" }, // This will be 50% on extra small screens and 100% on small screens and up
                        }}
                      />
                    </div>

                    <Typography
                      variant="h6"
                      sx={{
                        width: "100%",

                        marginTop: "10px",
                        marginBottom: "15px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: 700,
                        fontSize: "16px",
                        lineHeight: "100%",
                        letterSpacing: "0em",
                        textAlign: "center",
                        color: "#32324D",
                        //width: "100px",
                        height: "19px",
                        transform: "rotate(0deg)",
                        opacity: 1,
                        transition: "color 0.3s ease",
                        "&:hover": {
                          color: "#E63D57",
                        },
                      }}
                    >
                      Tirage {p.NomProduit}
                    </Typography>
                  </Box>
                </Link>
              </Grid>
            ))}
            {/* 
        <Grid item xs={6}>
          <Link to="/polaroid" style={{ textDecoration: "none" }}>
            <Box sx={stylebox}>
              <Box
                component="img"
                src={polaroid}
                alt="polaroid"
                sx={{
                  borderRadius: "30px",
                  width: { xs: "100%", sm: "50%" }, // This will be 50% on extra small screens and 100% on small screens and up
                }}
              />
              <Typography variant="h6" sx={TextStyle}>
                Tirage polaroid
              </Typography>{" "}
            </Box>
          </Link>
        </Grid>
        <Grid item xs={6}>
          <Link to="/instax" style={{ textDecoration: "none" }}>
            <Box sx={stylebox}>
              <Box
                component="img"
                src={instax}
                alt="instax"
                sx={{
                  borderRadius: "30px",
                  width: { xs: "100%", sm: "50%" }, // This will be 50% on extra small screens and 100% on small screens and up
                }}
              />
              <Typography variant="h6" sx={TextStyle}>
                Tirage instax
              </Typography>
            </Box>
          </Link>
        </Grid>*/}
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Link to="/event" style={{ textDecoration: "none" }}>
                <Box>
                  <Box
                    component="img"
                    src={event}
                    alt="instax"
                    sx={{
                      borderRadius: "30px",
                      width: { xs: "100%", sm: "80%" }, // 100% on extra small, 80% on small and up
                      display: "block",
                      margin: "0 auto",
                      mb: "30px",
                    }}
                  />
                  <Typography variant="h4" color="black" sx={TextStyle}>
                    Evenements
                  </Typography>
                </Box>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </div>
      <BottomBar />
    </>
  );
}
